/// <reference path="../../../../typings/index.d.ts" />

module Meevo.ChangePassword {
  export class ChangePasswordController {
    context: IChangePasswordContext;

    static $inject = [
      '$window',
      '$mdDialog',
      'meevo.AppSettings',
      'meevo.components.common.IdentityService',
      'meevo.components.common.DataService',
      '$translate',
      'model',
      'userId',
      'userName',
      'requireChangePassword'
    ];

    public locals: {
        model: any,
        userId: any,
        userName: any,
        requireChangePassword?: boolean,
        headerTitle?: string,
        isHandleRequest?: boolean
    };

    public title: string;

    constructor(private $window: angular.IWindowService,
      private $mdDialog: angular.material.IDialogService,
      private appSettings: Meevo.Components.Common.IAppSettings,
      private identityService: Meevo.Components.Common.IIdentityService,
      private dataService: Meevo.Components.BaseClasses.IDataService,
      private $translate: angular.translate.ITranslateService,
      private model: any,
      private userId: any,
      private userName: any,
      private requireChangePassword?: boolean
    ) {
      let handler = () => { this.$mdDialog.hide(); };
      this.title = (!!this.locals && !!this.locals.headerTitle) ? this.locals.headerTitle : 'LABEL_CHANGE_PASSWORD';
      let handleRequest =  (!!this.locals && this.locals.isHandleRequest) ? (newPassword: string) => { this.$mdDialog.hide(newPassword); } : null;
      this.context = new ChangePasswordContext(appSettings, dataService, identityService, $translate, handler, model, userId, userName, requireChangePassword, handleRequest);
    }

    close() {
      this.$mdDialog.hide();
    }
  }

  angular.module('meevo')
    .controller('meevo.changePassword.ChangePasswordController', ChangePasswordController);
}
